import React from 'react';
import { Skeleton } from '@components/ui/skeleton';
import Container from "@components/ui-old/container";
const EventsCardsLoader: React.FC = () => {
  const skeletonCards = Array.from({
    length: 4
  });
  return <Container data-sentry-element="Container" data-sentry-component="EventsCardsLoader" data-sentry-source-file="events-loader.tsx">
      <div className="py-16 lg:py-20 px-0 max-w-5xl mx-auto space-y-8">
      <div className="w-3/4">
          <Skeleton className="h-6 mb-4" aria-label="Loading quote" data-sentry-element="Skeleton" data-sentry-source-file="events-loader.tsx" />
          <Skeleton className="h-6 w-1/2" aria-label="Loading quote continuation" data-sentry-element="Skeleton" data-sentry-source-file="events-loader.tsx" />
        </div>
        <div className="grid grid-cols-1 gap-8">
          {skeletonCards.map((_, index) => <div key={index} className="border rounded-lg p-6 shadow-lg">
              <div className="w-full h-48 bg-gray-200 dark:bg-neutral-700 rounded-md overflow-hidden">
                <Skeleton className="w-full h-full" aria-label="Loading image" />
              </div>              
              <div className="mt-4">
                <Skeleton className="h-6 w-3/4 mb-2" aria-label="Loading title" />
                <Skeleton className="h-4 w-full mb-4" aria-label="Loading description" />
                <Skeleton className="h-4 w-1/2" aria-label="Loading link" />
              </div>              
              <div className="mt-4">
                <Skeleton className="h-10 w-24" aria-label="Loading button" />
              </div>
            </div>)}
        </div>
      </div>
    </Container>;
};
export default React.memo(EventsCardsLoader);